import axios from "axios";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";
import routes from "../../configs/api";

const addVendor = async (payload) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const URL = `${routes.ADD_VENDOR}`; // same base as GET — POST to this

  console.log("Adding Vendor API:", URL, payload);

  return new Promise((resolve, reject) => {
    axios
      .post(URL, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default addVendor;
